"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateReservationRequestToJSON = exports.CreateReservationRequestFromJSONTyped = exports.CreateReservationRequestFromJSON = exports.instanceOfCreateReservationRequest = void 0;
var CampaignAdProduct_1 = require("./CampaignAdProduct");
/**
 * Check if a given object implements the CreateReservationRequest interface.
 */
function instanceOfCreateReservationRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "endDate" in value;
    isInstance = isInstance && "country" in value;
    isInstance = isInstance && "adProduct" in value;
    return isInstance;
}
exports.instanceOfCreateReservationRequest = instanceOfCreateReservationRequest;
function CreateReservationRequestFromJSON(json) {
    return CreateReservationRequestFromJSONTyped(json, false);
}
exports.CreateReservationRequestFromJSON = CreateReservationRequestFromJSON;
function CreateReservationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'startDate': (new Date(json['start_date'])),
        'endDate': (new Date(json['end_date'])),
        'country': json['country'],
        'adProduct': (0, CampaignAdProduct_1.CampaignAdProductFromJSON)(json['ad_product']),
    };
}
exports.CreateReservationRequestFromJSONTyped = CreateReservationRequestFromJSONTyped;
function CreateReservationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'start_date': (value.startDate.toISOString()),
        'end_date': (value.endDate.toISOString()),
        'country': value.country,
        'ad_product': (0, CampaignAdProduct_1.CampaignAdProductToJSON)(value.adProduct),
    };
}
exports.CreateReservationRequestToJSON = CreateReservationRequestToJSON;
